import {
  RESTAURANT_DETAILS_REQUEST,
  RESTAURANT_DETAILS_SUCCESS,
  RESTAURANT_DETAILS_FAILURE,
  RESTAURANT_LIST_ITEMS
} from '../constants'

export const getRestaurantDetails = (data, sliceCount) => async (dispatch) => {
  try {
    dispatch({ type: RESTAURANT_DETAILS_REQUEST })

    const products = data.categories.flatMap((item) => item.products)

    let slicedShownItems = []
    let slicedDropdownItems = []

    if (data.categories.length > sliceCount) {
      slicedShownItems = data.categories.slice(0, sliceCount)
      slicedDropdownItems = data.categories.slice(sliceCount)
    } else {
      slicedShownItems = data.categories
    }

    dispatch({
      type: RESTAURANT_LIST_ITEMS,
      payload: {
        slicedShownItems,
        slicedDropdownItems
      }
    })
    dispatch({
      type: RESTAURANT_DETAILS_SUCCESS,
      payload: {
        details: data,
        products
      }
    })
  } catch {
    dispatch({
      type: RESTAURANT_DETAILS_FAILURE,
      payload: 'error'
    })
  }
}
